import React, { useState, useEffect, useRef } from "react"
import MetaTags from 'react-meta-tags';
import { Link , Redirect, useHistory} from "react-router-dom"
import Select from "react-select"
import CreatableSelect from 'react-select/creatable';
import PropTypes from "prop-types"
import {showCloseableToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  InputGroup,
  Input,
  Label,
  Tooltip,
  NavLink,
  Progress,
  Row,
  TabContent,
  TabPane,
  Button,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  UncontrolledDropdown
} from "reactstrap"

import { useReactToPrint } from "react-to-print";

import * as moment from "moment"
import classnames from "classnames"
import { useSelector, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
//Import Breadcrumb
import { setTimeCounter } from "store/products/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getStockBalance as onGetStockBalanceDirect } from "helpers/backend_helper"

import RightDrawer from "../../components/Common/RightDrawer"
import Loader from "components/Common/Loader"
import { getAllCustomers as onGetAllCustomers } from "store/products/actions"
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import { getProductsDropDown } from "helpers/backend_helper"
import { getProductsDropDownFromCache } from "helpers/cache_helper"
import COADropDown from "../../components/Product/COADropDown"

import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { getSalesEntryForEditDirect } from "helpers/backend_helper"
import { getStoreDetailsFromCache } from "helpers/cache_helper"

import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

const SalesReturnEntry = (props) => {

  const dispatch = useDispatch()
  const history = useHistory()
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  useEffect(() => {
    dispatch(onGetAllCustomers(true))
    dispatch(onGetStoreSettings(true))
    getPdtDropDown()
    fetchStoreDetails()
  }, [dispatch]);

  async function getPdtDropDown(){
    //const pdtdropdown = await getProductsDropDown()
    const pdtdropdown = await getProductsDropDownFromCache(true)
    setProductList(pdtdropdown)
  }

  const rateTypeOptions = [
    {
      label: "MRP",
      value: "mrp"
    },{
      label: "Retail",
      value: "retailprice"
    },{
      label: "Wholesale",
      value: "wholesaleprice"
    }
  ]

  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)
  const [selectedRows, setSelectedRows] = useState([])

  const [enteredText, setEnteredText] = useState('')
  const [storeDetails, setStoreDetails] = useState({})
  const [savedSuccessFully, setSavedSuccessFully] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [isEdit, setIsEdit] = useState(false)

  const [showWarningPopUp, setShowWarningPopUp] = useState(false)
  const [warningMessage, setWarningMessage] = useState('')
  
  const [socialDrp, setsocialDrp] = useState(false)
  const [defaultCustomer, setDefaultCustomer] = useState()
  const [defaultSaleRateType, setDefaultSaleRateType] = useState()
  const [currentAddedValue, setCurrentAddedValue] = useState()
  const [newItemToAdd, setNewItemToAdd] = useState()
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [showLoading, setShowLoading] = useState(false)
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [selectedRateType, setSelectedRateType] = useState(null)
  const [productList, setProductList] = useState([])
  const [salesEntryForEdit, setSalesEntryForEdit] = useState({})
  const [confirmationId, setConfirmationId] = useState('')
  
  const getAnewRow = (index) => {
    return { 
      idx: index , 
      id:"", 
      value: "",
      productid: "",
      productname: "",
      productqty: "0",
      productrate: "0",
      productgross: "0",
      productdisc: "0",
      productgrosswithouttax: "0",
      productnet: "0",
      producttotal: "0",
      gstpercentage: "0",
      cgstpercentage: "0",
      sgstpercentage: "0",
      igstpercentage: "0",
      productcgst: "0",
      productsgst: "0",
      productigst: "0",
      productgst: "0",
      purchaserate: "0",
      profitamount: "0",
      profitwithouttax: "0",
      unitlist: [],
      selectedunitid: "",
      selectedunitname: "",
      hsncode: "",
      selectedunitoption: {},
      conversionrate: "1",
      effectiveproductqty: "0",
      purchaseaccountid : "",
      purchasediscountaccountid : "",
      purchasereturnaccountid :"",
      saleaccountid :"",
      salediscountaccountid :"",
      salereturnaccountid :"",
    }
  }

  const initializeSalesEntry = () => {
    return {
      invoicedate: moment(new Date()).format("yyyy-MM-DD HH:mm"),
      invoiceno: "",
      id:"",
      status:"",
      customerid: "",
      ratetype: "",
      salesaccountid: "",
      paymentaccountid: "",
      
      totalqty: "0",
      totalgross: "0",
      totaldisc: "0",
      totalgrosswithouttax: "0",
      totalcgst: "0",
      totalsgst: "0",
      totaligst: "0",
      totalgst: "0",
      totaltotal: "0",
  
      loadingcharges: "0",
      othercharges: "0",
      discounts: "0",
      roundoff: "0",
      cashreceived: "0",
      grandtotal: "0",
      grandtotalbeforeround: "0",
      tendercash: "0",
      tenderbalance: "0",
      balanceamount: "0",
      totalprofitamount:"0",
      totalprofitwithouttaxamount: 0,
      notes: "",
      salesRows:[],
      salesRowsToRemove:[],
      sgstArray: [],
      cgstArray: [],
      igstArray: [],
    }
  }
  const [salesRows, setSalesRows] = useState([getAnewRow(1)])
  const [salesEntry, setSalesEntry] = useState(initializeSalesEntry())
  const [salesReturnRows, setSalesReturnRows] = useState([])
  const [salesReturnEntry, setSalesReturnEntry] = useState(initializeSalesEntry())

  const [validation, setValidation] = useState({
    invoicedate: null,
    suppinvoiceno: null,
  })

  const { customerList, settings} = useSelector(state => ({
    customerList: state.Products.customers,
    settings: state.Products.settings,
  }))

  function fetchStoreDetails(){
    getStoreDetailsFromCache(true).then(resp =>{
      setStoreDetails(resp)
    })
  }
  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      setIsEdit(true)
      setShowLoading(true)
      getSalesEntryDetails(params.id)
    } 
  }, [])

  async function getSalesEntryDetails(pdtid){
    const response = await getSalesEntryForEditDirect(pdtid)
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.id){
      setSalesEntryForEdit((response))
    }
    setShowLoading(false)
  }


  useEffect(() => {

    if(currentAddedValue){
      const newlyAddedOption = customerList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedCustomer(newlyAddedOption[0])
        setSalesEntry({
          ...salesEntry,
          customerid : newlyAddedOption[0].value
        })
      }
    }
    else if(isEdit && customerList && customerList.length > 0 && salesEntryForEdit && salesEntryForEdit.customerid){
        const custOption = customerList.filter(each => each.value === salesEntryForEdit.customerid)
        if(custOption && custOption.length == 1){
          setSelectedCustomer(custOption[0])
          setSalesEntry({
            ...salesEntry,
            customerid : custOption[0].value
          })
        }
    }
    else if(customerList && customerList.length > 0){
      const custOption = customerList.filter(each => each.value == '5000')
        if(custOption && custOption.length == 1){
          setDefaultCustomer(custOption[0])
          setSelectedCustomer(custOption[0])
          setSalesEntry({
            ...salesEntry,
            customerid : custOption[0].value
          })
        }
    }
  }, [customerList]);

  useEffect(() => {
    if (salesEntryForEdit && isEdit && params.id == salesEntryForEdit.id) {
      
      let salesRowsTemp = []
      let index = 1;

      salesEntryForEdit.salesRows.forEach(each => {
        let productname = ''
        let cgstper = '0'
        let sgstper = '0'
        let igstper = '0'
        let gstper = '0'
        let prodrate = '0'
        let purchaseratetemp = '0'
        let unitlisttemp = []
        let selectedunitoptiontemp = {}
        let conversionratetemp = '1'

        let purchaseaccountidtemp = ''
        let purchasediscountaccountidtemp = ''
        let purchasereturnaccountidtemp = ''
        let saleaccountidtemp = ''
        let salediscountaccountidtemp = ''
        let salereturnaccountidtemp = ''

        let hsncodetemp = ''

        if(productList && productList.length > 0){
          const foundValue = productList.filter(x => x["productid"] == each.productid)
          if(foundValue && foundValue.length == 1){
            productname = foundValue[0].label
            cgstper = foundValue[0].cgst
            sgstper = foundValue[0].sgst
            igstper = foundValue[0].igst
            gstper =  foundValue[0].gst
            hsncodetemp =  foundValue[0].hsncode

            purchaseaccountidtemp = foundValue[0].purchaseaccountid
            purchasediscountaccountidtemp = foundValue[0].purchasediscountaccountid
            purchasereturnaccountidtemp = foundValue[0].purchasereturnaccountid
            saleaccountidtemp = foundValue[0].saleaccountid
            salediscountaccountidtemp = foundValue[0].salediscountaccountid
            salereturnaccountidtemp = foundValue[0].salereturnaccountid

            unitlisttemp = foundValue[0].units
            const foundUnit = unitlisttemp.filter(x => x["unitid"] == each.selectedunitid)
            if(foundUnit && foundUnit.length == 1){
              selectedunitoptiontemp = foundUnit[0]
              conversionratetemp = foundUnit[0].conversionrate
            }
            //prodrate = foundValue[0][salesEntry.ratetype]
            //purchaseratetemp = foundValue[0].baseprice
          }
        }

        salesRowsTemp.push({
          ...each,
          idx: index++ , 
          value: each.id,
          productname: productname,
          cgstpercentage: cgstper,
          sgstpercentage: sgstper,
          igstpercentage: igstper,
          gstpercentage: gstper,
          hsncode: hsncodetemp,
          selectedunitoption: selectedunitoptiontemp,
          unitlist: unitlisttemp,
          conversionrate: conversionratetemp,
          purchaseaccountid : purchaseaccountidtemp,
          purchasediscountaccountid : purchasediscountaccountidtemp,
          purchasereturnaccountid :purchasereturnaccountidtemp,
          saleaccountid :saleaccountidtemp,
          salediscountaccountid :salediscountaccountidtemp,
          salereturnaccountid :salereturnaccountidtemp,
          //productrate: prodrate,
          //purchaserate: purchaseratetemp
        })
      })

      setSalesRows(salesRowsTemp)
      if(customerList && customerList.length > 0 && salesEntryForEdit.customerid){
        const custOption = customerList.filter(each => each.value === salesEntryForEdit.customerid)
        if(custOption && custOption.length == 1){
          setSelectedCustomer(custOption[0])
        }
      }

      setSalesEntry({
        ...salesEntry,
        id: salesEntryForEdit.id,
        status: salesEntryForEdit.status,
        invoicedate: salesEntryForEdit.invoicedate,
        customerid: salesEntryForEdit.customerid,
        ratetype: salesEntryForEdit.ratetype,
        invoiceno: salesEntryForEdit.invoiceno,
        paymentaccountid: salesEntryForEdit.paymentaccountid,
        totalqty: salesEntryForEdit.totalqty,
        totalgross: salesEntryForEdit.totalgross,
        totaldisc: salesEntryForEdit.totaldisc,
        //totalnet: salesEntryForEdit.totalnet,
        totalgrosswithouttax: salesEntryForEdit.totalgrosswithouttax,
        totalcgst: salesEntryForEdit.totalcgst,
        totalsgst: salesEntryForEdit.totalsgst,
        totaligst: salesEntryForEdit.totaligst,
        totalgst: salesEntryForEdit.totalgst,
        totaltotal: salesEntryForEdit.totaltotal,

        loadingcharges: salesEntryForEdit.loadingcharges,
        othercharges: salesEntryForEdit.othercharges,
        discounts: salesEntryForEdit.discounts,
        cashreceived: salesEntryForEdit.cashreceived,
        balanceamount: salesEntryForEdit.balanceamount,
        grandtotal: salesEntryForEdit.grandtotal,
        grandtotalbeforeround: salesEntryForEdit.grandtotal,
        roundoff: salesEntryForEdit.roundoff,
        tendercash: salesEntryForEdit.tendercash,
        tenderbalance: salesEntryForEdit.tenderbalance,
        totalprofitamount: salesEntryForEdit.totalprofitamount,
        totalprofitwithouttaxamount: salesEntryForEdit.totalprofitwithouttaxamount,
        notes: salesEntryForEdit.notes,
        salesRows:salesRowsTemp
      })
    }
  },[salesEntryForEdit])

  useEffect(() => {
    if(settings && settings.length > 0){
      const saleType = settings.filter(each => each.settingid == 'DEFAULT_SALE_RATE_TYPE')
      if(saleType && saleType.length > 0){
        const defaultsaletype = saleType[0].settingvalue
        const foundDefault = rateTypeOptions.filter(eachInn => eachInn.value == defaultsaletype)
        if(foundDefault){
          setSelectedRateType(foundDefault[0])
          setDefaultSaleRateType(foundDefault[0])
          setSalesEntry({
            ...salesEntry,
            ratetype : foundDefault[0].value
          })
        }
      }
    }
  }, [settings]);

  const mandatoryFields = ['invoicedate','customerid']

  const onChangeValidation = (fieldName, value) => {
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }

  useEffect(() => {
    let totalqtytemp = 0
    let totalgrosstemp = 0
    let totaldisctemp = 0
    //let totalnettemp = 0
    let totalgrosswithouttaxtemp = 0
    let totalcgsttemp = 0
    let totalsgsttemp = 0
    let totaligsttemp = 0
    let totalgsttemp = 0
    let totaltotaltemp = 0
    let totalprofitamounttemp = 0
    let totalprofitamountwotaxtemp = 0

    let sgstArray = []
    let cgstArray = []
    let igstArray = []

    //sgstGroupTotal
    salesReturnRows.forEach(each => {
      totalqtytemp = totalqtytemp + Number(each["productqty"])
      totalgrosstemp = totalgrosstemp + Number(each["productgross"])
      totaldisctemp = totaldisctemp + Number(each["productdisc"])
      //totalnettemp = totalnettemp + Number(each["productnet"])
      totalgrosswithouttaxtemp = totalgrosswithouttaxtemp + Number(each["productgrosswithouttax"])
      totalcgsttemp = totalcgsttemp + Number(each["productcgst"])
      totalsgsttemp = totalsgsttemp + Number(each["productsgst"])
      totaligsttemp = totaligsttemp + Number(each["productigst"])
      totalgsttemp = totalgsttemp + Number(each["productgst"])
      totaltotaltemp = totaltotaltemp + Number(each["producttotal"])
      totalprofitamounttemp = totalprofitamounttemp + Number(each["profitamount"])
      totalprofitamountwotaxtemp = totalprofitamountwotaxtemp + Number(each["profitwithouttax"])

      if(Number(each["sgstpercentage"]) > 0){
        let filteredsgst =  sgstArray.filter(each1 => Number(each1.tax) == Number(each["sgstpercentage"]))
        if(filteredsgst && filteredsgst.length > 0){
          sgstArray = sgstArray.map(eachMapItem => {
            if(Number(eachMapItem.tax) == Number(each["sgstpercentage"])){
              return {
                ...eachMapItem,
                taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                taxamount : Number(eachMapItem.taxamount) + Number(each["productsgst"])
              }
            }
            else{
              return eachMapItem
            }
          })
        }
        else{
          sgstArray.push({
            tax: each["sgstpercentage"],
            taxamount: each["productsgst"],
            taxableamount : each["productgrosswithouttax"]
          })
        }
      }

      if(Number(each["cgstpercentage"]) > 0){
        let filteredcgst =  cgstArray.filter(each1 => Number(each1.tax) == Number(each["cgstpercentage"]))
        if(filteredcgst && filteredcgst.length > 0){
          cgstArray = cgstArray.map(eachMapItem => {
            if(Number(eachMapItem.tax) == Number(each["cgstpercentage"])){
              return {
                ...eachMapItem,
                taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                taxamount : Number(eachMapItem.taxamount) + Number(each["productcgst"])
              }
            }
            else{
              return eachMapItem
            }
          })
        }
        else{
          cgstArray.push({
            tax: each["cgstpercentage"],
            taxamount: each["productcgst"],
            taxableamount : each["productgrosswithouttax"]
          })
        }
      }

      if(Number(each["igstpercentage"]) > 0){
        let filteredigst =  igstArray.filter(each1 => Number(each1.tax) == Number(each["igstpercentage"]))
        if(filteredigst && filteredigst.length > 0){
          igstArray = igstArray.map(eachMapItem => {
            if(Number(eachMapItem.tax) == Number(each["igstpercentage"])){
              return {
                ...eachMapItem,
                taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                taxamount : Number(eachMapItem.taxamount) + Number(each["productigst"])
              }
            }
            else{
              return eachMapItem
            }
          })
        }
        else{
          igstArray.push({
            tax: each["igstpercentage"],
            taxamount: each["productigst"],
            taxableamount : each["productgrosswithouttax"]
          })
        }
      }

    })

    let grandtotaltemp = Number(totaltotaltemp + Number(salesEntry.loadingcharges) + Number(salesEntry.othercharges) - Number(salesEntry.discounts)).toFixed(2)
    const grandtotaltempafterround = Math.round(grandtotaltemp)
    const roundofftemp = grandtotaltempafterround - grandtotaltemp
    setSalesReturnEntry({
      ...salesReturnEntry,
      sgstArray : sgstArray,
      cgstArray : cgstArray,
      igstArray : igstArray,
      totalqty: Number(totalqtytemp).toFixed(2),
      totalgross: Number(totalgrosstemp).toFixed(2),
      totaldisc: Number(totaldisctemp).toFixed(2),
      //totalnet: Number(totalnettemp).toFixed(2),
      totalgrosswithouttax: Number(totalgrosswithouttaxtemp).toFixed(2),
      totalcgst: Number(totalcgsttemp).toFixed(2),
      totalsgst: Number(totalsgsttemp).toFixed(2),
      totaligst: Number(totaligsttemp).toFixed(2),
      totalgst: Number(totalgsttemp).toFixed(2),
      totaltotal: Number(totaltotaltemp).toFixed(2),
      cashreceived: isEdit? salesEntry.cashreceived : Number(grandtotaltempafterround).toFixed(2), //incase of edit, just keeping the same amount
      roundoff: Number(roundofftemp).toFixed(2),
      balanceamount: isEdit? (Number(grandtotaltempafterround) - Number(salesEntry.cashreceived)) : 0,
      grandtotalbeforeround: Number(grandtotaltemp).toFixed(2),
      grandtotal: Number(grandtotaltempafterround).toFixed(2),
      tenderbalance: (Number(salesEntry.tendercash) - Number(grandtotaltempafterround)).toFixed(2),
      totalprofitamount: Number(totalprofitamounttemp).toFixed(2),
      totalprofitwithouttaxamount: Number(totalprofitamountwotaxtemp).toFixed(2),
      salesRows:salesReturnRows
    })
  }, [salesReturnRows]);

  function getGrossFromRow(currentRow){
    if(isNumber(currentRow["productqty"]) && isNumber(currentRow["productrate"])){
      return (Number(currentRow["productqty"]) * Number(currentRow["productrate"])).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getGrossWithoutTaxFromRow(currentRow){
    if(isNumber(currentRow["productqty"]) && isNumber(currentRow["productrate"]) && isNumber(currentRow["gstpercentage"])){
      //qty * product rate / 1.gst
      return (Number(currentRow["productqty"]) * (Number(currentRow["productrate"]) / ( 1 + (Number(currentRow["gstpercentage"])) /100) )).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getNetFromRow(currentRow){
    
    if(isNumber(currentRow["productgst"]) && isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["productdisc"])){
      return (Number(currentRow["productgrosswithouttax"]) + Number(currentRow["productgst"]) - currentRow["productdisc"]).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getCGSTFromRow(currentRow){
    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }
    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["cgstpercentage"])){
      return (( (currentRow["productgrosswithouttax"] - discount ) * currentRow["cgstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getSGSTFromRow(currentRow){

    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }

    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["sgstpercentage"])){
      return (((currentRow["productgrosswithouttax"] - discount )  * currentRow["sgstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getIGSTFromRow(currentRow){

    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }

    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["igstpercentage"])){
      return (((currentRow["productgrosswithouttax"] - discount )  * currentRow["igstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getGSTFromRow(currentRow){

    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }

    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["gstpercentage"])){
      return (((currentRow["productgrosswithouttax"] - discount )  * currentRow["gstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getTotalFromRow(currentRow){
    //const total = Number(currentRow["productnet"]) + Number(currentRow["productcgst"]) + Number(currentRow["productsgst"]) + Number(currentRow["productigst"])
    //return Number(total).toFixed(2)
    if(isNumber(currentRow["productgst"]) &&  isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["productdisc"])){
      return (Number(currentRow["productgrosswithouttax"]) + Number(currentRow["productgst"]) - currentRow["productdisc"]).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }
  function getProfitForEachFromRow(currentRow){
    if(isNumber(currentRow["producttotal"]) && isNumber(currentRow["productqty"])){
      return (Number(currentRow["producttotal"]) - (Number(currentRow["purchaserate"]) * Number(currentRow["productqty"]))).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getProfitWithoutTaxForEachFromRow(currentRow){
    return (Number(currentRow["profitamount"]) / (1+(Number(currentRow["gstpercentage"])/100))).toFixed(2)
  }

  function handleRateTypeChange(ratetypeinp){
    setSalesEntry({
      ...salesEntry,
      ratetype : ratetypeinp
    })

    var modifiedRows = [...salesReturnRows]
    modifiedRows = modifiedRows.map(eachRow => {
      let prodrate = eachRow["selectedunitoption"][ratetypeinp]
      /*
      if(productList && productList.length > 0){
        const foundValue = productList.filter(x => x["productid"] == eachRow.productid)
        if(foundValue && foundValue.length == 1){
          prodrate = foundValue[0][ratetypeinp]
        }
      }*/
      eachRow["productrate"] = prodrate
      eachRow = recalculateEachRow(eachRow)
      return {
        ...eachRow,
        productrate : prodrate
      }
    })
    setSalesReturnRows(modifiedRows)
  }

  function handleUnitChangeV2(id, selected) {
    //console.log('selected:'+JSON.stringify(selected))
    var modifiedRows = [...salesReturnRows]
      modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){

        eachRow["selectedunitoption"] = selected
        eachRow["selectedunitid"] = selected.unitid
        eachRow["selectedunitname"] = selected.name
        eachRow["productrate"] = selected[salesEntry.ratetype]
        eachRow["purchaserate"] = selected.baseprice
        eachRow["conversionrate"] = selected.conversionrate
        eachRow["effectiveproductqty"] = (Number(eachRow["productqty"]) / Number(selected.conversionrate)).toFixed(3)
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow
        }
      }
      else {
        return eachRow
      }
    })
    setSalesReturnRows(modifiedRows)
  }


  function handleQtyChangeV2(id, value) {
    var modifiedRows = [...salesReturnRows]

    modifiedRows = modifiedRows.map(eachRow => {

      if(eachRow["idx"] == id){
        eachRow["productqty"] = value
        eachRow["effectiveproductqty"] = (Number(value) / Number(eachRow["conversionrate"])).toFixed(3)
        eachRow = recalculateEachRow(eachRow)

        return {
          ...eachRow,
          productqty: value,
        }
      }
      else {
        return eachRow
      }
    })
    setSalesReturnRows(modifiedRows)
  }

  function recalculateEachRow(eachRow){

    eachRow["productgross"] = getGrossFromRow(eachRow)
    eachRow["productgrosswithouttax"] = getGrossWithoutTaxFromRow(eachRow)
    eachRow["productnet"] = getNetFromRow(eachRow)
    eachRow["productcgst"] = getCGSTFromRow(eachRow)
    eachRow["productsgst"] = getSGSTFromRow(eachRow)
    eachRow["productigst"] = getIGSTFromRow(eachRow)
    eachRow["productgst"] = getGSTFromRow(eachRow)
    eachRow["producttotal"] = getTotalFromRow(eachRow)

    eachRow["profitamount"] = getProfitForEachFromRow(eachRow)
    eachRow["profitwithouttax"] = getProfitWithoutTaxForEachFromRow(eachRow)

    return eachRow
  }

  function handleRateChangeV2(id, value) {
    var modifiedRows = [...salesReturnRows]
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        eachRow["productrate"] = value
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow,
          productrate: value,
        }
      }
      else {
        return eachRow
      }
    })
    setSalesReturnRows(modifiedRows)
  }

  function handleDiscountChangeV2(id, value) {
    var modifiedRows = [...salesReturnRows]

    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        eachRow["productdisc"] = value
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow,
          productdisc: value,
        }
      }
      else {
        return eachRow
      }
    })
    setSalesReturnRows(modifiedRows)
  }


  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  function validateTextNumberInput(key,value){
    if(value && value != "" && isNumber(value) && Number(value) > 0){
      setValidation({
        ...validation,
        [key]:true
      })
    }
    else{
      setValidation({
        ...validation,
        [key]:true
      })
    }
  }

  function validateForm() {
    const modifiedV = { ...validation }
    
    //const lastRow = salesRows[salesRows.length-1]
    //console.log('lastRow:'+JSON.stringify(lastRow))
    let formValid = true;

    for (let index = 0; index < salesReturnRows.length; index++) {
      const lastRow = salesReturnRows[index];
      if(lastRow["productid"] && lastRow["productid"] != ""){
        modifiedV["pdtitem-"+(index+1)] = true
      }
      else{
        modifiedV["pdtitem-"+(index+1)] = false
        formValid = false
      }
  
      if(lastRow["productqty"] && lastRow["productqty"] != "" && isNumber(lastRow["productqty"]) && Number(lastRow["productqty"]) > 0){
        modifiedV["productqty-"+(index+1)] = true
      }
      else{
        modifiedV["productqty-"+(index+1)] = false
        formValid = false
      }
  
      if(lastRow["productrate"] && lastRow["productrate"] != "" && isNumber(lastRow["productrate"]) && Number(lastRow["productrate"]) > 0){
        modifiedV["productrate-"+(index+1)] = true
      }
      else{
        modifiedV["productrate-"+(index+1)] = false
        formValid = false
      }
    }

    setValidation(modifiedV)
    return formValid
  }

  function validateFormSubmit(){
    let formValid = true;
    const modifiedV = { ...validation }
    mandatoryFields.forEach(eachItem =>{
      if(salesEntry[eachItem] && salesEntry[eachItem].trim() != ""){
        modifiedV[eachItem] = true
      }
      else{
        modifiedV[eachItem] = false
        formValid = false
      }
    })
    setValidation(modifiedV)

    return formValid
  }

  function addSalesReturnEntry(){
    let isFormValid = validateFormSubmit()
    if(isFormValid){
      isFormValid = validateForm()
    }
    if(isFormValid){
      const salesEntryTemp = { ...salesReturnEntry }
      salesEntryTemp["status"] = 'ACTIVE'
      submitCreateNewSalesEntry(salesEntryTemp)
    }
  }

  function draftSalesEntry(){
      const salesEntryTemp = { ...salesEntry }
      salesEntryTemp["status"] = 'DRAFT'
      submitCreateNewSalesEntry(salesEntryTemp)
  }

  function updateDraftSalesEntry(){
    const salesEntryTemp = { ...salesEntry }
    salesEntryTemp["status"] = 'DRAFT'
    submitUpdateSalesEntry(salesEntryTemp)
  }

  function updateSalesEntry(){
    let isFormValid = validateFormSubmit()
    if(isFormValid){
      isFormValid = validateForm()
    }
    if(isFormValid){
      const salesEntryTemp = { ...salesEntry }
      salesEntryTemp["status"] = 'ACTIVE'
      submitUpdateSalesEntry(salesEntryTemp)
    }
  }

  async function submitUpdateSalesEntry(salesEntryDetails) {
    setShowLoading(true)
    const response = await onEditItemDirect(salesEntryDetails, 'SalesEntry')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      setConfirmationId(salesEntryDetails.id)
      setShowSuccessPopUp(true)
      setSuccessMessage('Sales Entry Updated successfully.')
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  async function submitCreateNewSalesEntry(salesEntryDetails) {
    setShowLoading(true)
    const response = await onAddItemDirect(salesEntryDetails, 'SalesReturnEntry')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      setConfirmationId(response.responseId)
      setSalesEntry({
        ...salesEntry,
        invoiceno:response.confirmation_code
      })
      
      setSavedSuccessFully(true)
      setShowSuccessPopUp(true)
      setSuccessMessage('Sales Entry added successfully.')
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }


  function getSelectedProduct(idx){
    if(productList && salesRows && productList.length > 0 && salesRows.length > 0){
      const foundValue = productList.filter(x => x["productid"] == salesRows[idx-1].productid)
      return foundValue
    }
  }


  function addNewItem(item) {
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }

  function addNewSales(){
    setSalesRows([getAnewRow(1)])
    const baseSales = initializeSalesEntry()
    setSelectedRateType(defaultSaleRateType)
    setSelectedCustomer(defaultCustomer)
    setSavedSuccessFully(false)
    setSalesEntry({
      ...baseSales,
      ratetype: defaultSaleRateType.value,
      customerid: defaultCustomer.value
    })
  }

  const onContinueEditing = () => {
    if(confirmationId != ''){
      history.push('/edit-salesentry/'+confirmationId);
    }
  }

  const onCreateNewSales = () => {
      if(isEdit){
        history.push('/add-sales');
      }
      else{
        addNewSales()
    }
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Sales Return | Flamingo</title>
        </MetaTags>
        <Loader showLoader={showLoading} />
        <Container fluid>
          {isEdit ? 
          <Breadcrumbs title="Sales" breadcrumbItem="Sales Return" /> 
          :
          <Breadcrumbs title="Sales" breadcrumbItem="Sales Return" />
          }
          <Row>
            <Col lg="12">
              <Card style={{minHeight: "550px"}}>
                <CardBody>
                  <Form>
                    <Row>
                      <Col lg="6">
                        <Row>
                          <Col lg="4">
                            <FormGroup className="mb-4">
                              <Label>Invoice Date</Label>
                              <InputGroup>
                                <Flatpickr
                                  id="invoicedatefp"
                                  className="form-control d-block"
                                  placeholder="dd MM yyyy H:i"
                                  disabled
                                  readOnly
                                  value={salesEntry.invoicedate}
                                  options={{
                                    enableTime: true,
                                    altInput: true,
                                    altFormat: "j M Y, H:i",
                                    dateFormat: "Y-m-d H:i",
                                  }}
                                  onChange={date => {
                                    const date1 = moment(new Date(date)).format("yyyy-MM-DD HH:mm ")
                                    setSalesEntry({
                                      ...salesEntry,
                                      invoicedate : date1
                                    })
                                    onChangeValidation("invoicedate", date1)
                                  }}
                                />
                                {(validation["invoicedate"] === false) &&
                                  <div className="custom-error">
                                    Please select the Invoice Date
                                  </div>
                                }
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="8">
                            <FormGroup className="mb-4">
                              <Label>Customer</Label>
                                <Select
                                  onChange={(e) => {
                                    setSalesEntry({
                                      ...salesEntry,
                                      customerid : e.value
                                    })
                                    setSelectedCustomer(e)
                                    onChangeValidation("customerid", e.value)
                                  }}
                                  isDisabled={true}
                                  value={selectedCustomer}
                                  options={customerList}
                                  classNamePrefix="select2-selection"
                                  isLoading={false}
                                  id="productcustomer"
                                />
                                {(validation["customerid"] === false) &&
                                  <div className="custom-error">
                                    Please select the Customer
                                  </div>
                                }
                            </FormGroup>
                          </Col>
                          
                          
                        </Row>
                      </Col>
                      <Col lg="6">
                        <Row>
                        <Col lg="3">
                            <FormGroup className="mb-4">
                              <Label>Rate</Label>
                                <Select
                                  onChange={(e) => {
                                    handleRateTypeChange(e.value)
                                    setSelectedRateType(e)
                                  }}
                                  value={selectedRateType}
                                  options={rateTypeOptions}
                                  classNamePrefix="select2-selection"
                                />
                            </FormGroup>
                          </Col>
                          {isEdit && <Col className="ms-3" lg="4">
                            <FormGroup className="mb-4">
                              <Label>Invoice No.
                              <Badge className={salesEntry.status== "ACTIVE"? "ms-2 font-size-12 bg-success badge-success":"ms-2 font-size-12 bg-warning badge-warning"}>
                                {salesEntry.status}
                              </Badge>
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  disabled
                                  value={salesEntry.invoiceno || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          }
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="ms-1 font-size-16 text-center">
                        Sale Items
                      </Col>
                    </Row>
                    <div className="inner-repeater">
                      <div className="table-responsive">
                        <table style={{ width: "100%" }} className="0">
                          <tbody>
                            <tr className="custom-table-sales-header">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="5" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="2">#</Col>
                                      <Col className="custom-table-header-cell" xs="10">Item</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="3" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Qty</Col>
                                      <Col className="custom-table-header-cell" xs="3">Unit</Col>
                                      <Col className="custom-table-header-cell" xs="3">Rate</Col>
                                      <Col className="custom-table-header-cell" xs="3">Gross</Col>
                                      
                                      
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Base Rate</Col>
                                      {/*<Col className="custom-table-header-cell" xs="2">CGST</Col>
                                      <Col className="custom-table-header-cell" xs="2">SGST</Col>
                                      <Col className="custom-table-header-cell" xs="1">IGST</Col>*/}
                                      <Col className="custom-table-header-cell" xs="2">Disc</Col>
                                      <Col className="custom-table-header-cell" xs="2">GST</Col>
                                      <Col className="custom-table-header-cell" xs="3">Total</Col>
                                      <Col className="custom-table-header-cell" xs="2">Select</Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          
                            {(salesRows || []).map((formRow, key) => (
                              <tr key={key}>
                                <td>
                                  <Row className="no-gutters">
                                    <Col lg="5" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="2">
                                          <Input
                                            type="text"
                                            className="nopadd text-center"
                                            disabled
                                            value={formRow.idx}
                                          />
                                        </Col>
                                        <Col xs="10">
                                          <Select
                                            isDisabled={true}
                                            options={productList}
                                            classNamePrefix="select2-selection"
                                            isLoading={false}
                                            id={"productentry-"+key}
                                            menuPortalTarget= {document.body}
                                            autoFocus={true}
                                            value={getSelectedProduct(formRow.idx)}
                                          />
                                          {(validation["pdtitem-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Please select the Item
                                            </div>
                                          }
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg="3" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            type="text" //Qty
                                            disabled
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleQtyChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productqty-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productqty)}
                                          />
                                          {(validation["productqty-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Qty
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Select
                                            onChange={(e) => {
                                              handleUnitChangeV2(formRow.idx, e)
                                              //handleProductChangeV2(formRow.idx, e)
                                              //validatePdtChange("pdtitem-"+formRow.idx, e.productid)
                                            }}
                                            components={{
                                              DropdownIndicator: () => null,
                                              IndicatorSeparator: () => null
                                            }}
                                            isDisabled={true}
                                            options={(salesRows.filter(x => x["idx"]==formRow.idx)[0].unitlist)}
                                            classNamePrefix="select2-selection"
                                            className="text-center"
                                            isLoading={false}
                                            id={"unitlist-"+key}
                                            menuPortalTarget= {document.body}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].selectedunitoption)}
                                          />
                                          {(validation["unitlist-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Please select the Unit
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Rate
                                            disabled
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleRateChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productrate-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productrate)}
                                          />
                                          {(validation["productrate-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Rate
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Gross
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productgross)}
                                          />
                                        </Col>
                                        
                                        
                                      </Row>
                                    </Col>
                                    <Col lg="4" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            type="text" // Gross without tax
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productgrosswithouttax)}
                                          />
                                        </Col>
                                        <Col xs="2">
                                          <Input
                                            type="text" // Disc
                                            disabled
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleDiscountChangeV2(formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productdisc)}
                                          />
                                        </Col>

                                        <Col xs="2">
                                          <Input
                                            type="text" //GST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productgst)}
                                          />
                                        </Col>
                                        
                                        <Col xs="3">
                                          <Input
                                            type="text" //Total
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].producttotal)}
                                          />
                                        </Col>
                                        <Col xs="2" className="justify-content-center align-self-center text-center">
                                          <div className="add-remove-mob">
                                            <input
                                              type="checkbox"
                                              className="form-check-input font-size-20"
                                              id={"customCheck-outlinecolor1"+formRow.idx}
                                              checked={selectedRows.includes(formRow.productid)}
                                              onChange={() => {
                                                if(selectedRows.includes(formRow.productid)){
                                                  var modifiedRows = [...selectedRows]
                                                  modifiedRows = modifiedRows.filter(x => x !== formRow.productid)
                                                  setSelectedRows(modifiedRows)

                                                  var modifiedSalesReturnRows = [...salesReturnRows]
                                                  modifiedSalesReturnRows = modifiedSalesReturnRows.filter(x => x.productid !== formRow.productid)
                                                  setSalesReturnRows(modifiedSalesReturnRows)
                                                }
                                                else{
                                                  let currentRows = [...selectedRows]
                                                  currentRows.push(formRow.productid)
                                                  setSelectedRows(currentRows)

                                                  var modifiedSalesReturnRows = [...salesReturnRows]
                                                  let tempFormRow = {...formRow}
                                                  modifiedSalesReturnRows.push(tempFormRow)
                                                  setSalesReturnRows(modifiedSalesReturnRows)
                                                }
                                              }}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                    
                                  </Row>
                                  
                                </td>
                              </tr>
                            ))}

                            <tr className="custom-table-footer">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="5" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="1"></Col>
                                      <Col className="pt-2 fw-medium display-10" xs="11">Total</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="3" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3">
                                        <Input
                                            type="text" // total qty
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={salesEntry.totalqty || ''}
                                          />
                                      </Col>
                                      <Col className="" xs="3"></Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" //Gross
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalgross || ''}
                                        />
                                      </Col>

                                      
                                      
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" // net - totalgrosswithouttax
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalgrosswithouttax || ''}
                                        />
                                      </Col>
                                    {/*
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // CGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalcgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                      <Input
                                          type="text" // SGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalsgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="1">
                                        <Input
                                          type="text" // IGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totaligst || ''}
                                        />
                                      </Col>*/}
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // Disc
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totaldisc || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // GST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalgst || ''}
                                        />
                                      </Col>
                                      
                                      <Col className="" xs="5">
                                        <InputGroup>
                                          <Input
                                              type="text" // Grand Total
                                              disabled
                                              className="nopadd text-center form-control"
                                              value={salesEntry.totaltotal.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                          />
                                        </InputGroup>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <Row className="text-end">
                      <Col className="text-end">
                        <UncontrolledDropdown
                          className=""
                          isOpen={socialDrp}
                          toggle={() => {
                            setsocialDrp(!socialDrp)
                          }}
                        >
                          <DropdownToggle
                            className="btn "
                            href="#"
                            tag="i"
                            onClick={(e) => {e.stopPropagation()}}
                          >
                            <i className="bx bx-dots-horizontal" />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
                            <div className="px-lg-2 p-2 ms-2 me-2">
                              <dl className="row mb-0">

                                <dt className="col-sm-7">Loading Charges</dt>
                                <dd className="col-sm-5"><i className="bx bx-rupee "></i>{Number(salesEntry.loadingcharges).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                
                                <dt className="col-sm-7">Other Charges</dt>
                                <dd className="col-sm-5"><i className="bx bx-rupee "></i>{Number(salesEntry.othercharges).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                
                                <dt className="col-sm-7">Discounts</dt>
                                <dd className="col-sm-5"><i className="bx bx-rupee "></i>{Number(salesEntry.discounts).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                
                                <dt className="col-sm-7">Round Off</dt>
                                <dd className="col-sm-5"><i className="bx bx-rupee "></i>{Number(salesEntry.roundoff).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                <hr className="mb-2"/>
                                <dt className="col-sm-7">Grand Total</dt>
                                <dd className="col-sm-5 fw-bold"><i className="bx bx-rupee "></i>{Number(salesEntry.grandtotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                <hr/>
                                <dt className="col-sm-7">Cash Received</dt>
                                <dd className="col-sm-5"><i className="bx bx-rupee "></i>{Number(salesEntry.cashreceived).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                
                                <dt className="col-sm-7">Balance Amount</dt>
                                <dd className="col-sm-5"><i className="bx bx-rupee "></i>{Number(salesEntry.balanceamount).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                <hr className="mb-2"/>
                                <dt className="col-sm-4">Notes</dt>
                                <dd className="col-sm-8">{salesEntry.notes == '' ? '-':salesEntry.notes}</dd>
                                

                              </dl>
                            </div>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </Col>
                    </Row>

                    {salesReturnRows && salesReturnRows.length > 0 &&
                    <>
                    <Row>
                      <Col className="ms-1 font-size-16 text-center">
                        Sales Return Items
                      </Col>
                    </Row>
                    <div className="inner-repeater">
                      <div className="table-responsive">
                        <table style={{ width: "100%" }} className="0">
                          <tbody>
                            <tr className="custom-table-sales-header">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="5" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="2">#</Col>
                                      <Col className="custom-table-header-cell" xs="10">Item</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="3" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Qty</Col>
                                      <Col className="custom-table-header-cell" xs="3">Unit</Col>
                                      <Col className="custom-table-header-cell" xs="3">Rate</Col>
                                      <Col className="custom-table-header-cell" xs="3">Gross</Col>
                                      
                                      
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Base Rate</Col>
                                      <Col className="custom-table-header-cell" xs="2">Disc</Col>
                                      <Col className="custom-table-header-cell" xs="2">GST</Col>
                                      <Col className="custom-table-header-cell" xs="5">Total</Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          
                            {(salesReturnRows || []).map((formRow, key) => (
                              <tr key={key}>
                                <td>
                                  <Row className="no-gutters">
                                    <Col lg="5" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="2">
                                          <Input
                                            type="text"
                                            className="nopadd text-center"
                                            disabled
                                            value={key+1}
                                          />
                                        </Col>
                                        <Col xs="10">
                                          <Select
                                            isDisabled={true}
                                            options={productList}
                                            classNamePrefix="select2-selection"
                                            isLoading={false}
                                            id={"productentry-"+key}
                                            menuPortalTarget= {document.body}
                                            autoFocus={true}
                                            value={getSelectedProduct(formRow.idx)}
                                          />
                                          {(validation["pdtitem-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Please select the Item
                                            </div>
                                          }
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg="3" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            type="text" //Qty
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleQtyChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productqty-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].productqty)}
                                          />
                                          {(validation["productqty-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Qty
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Select
                                            onChange={(e) => {
                                              handleUnitChangeV2(formRow.idx, e)
                                              //handleProductChangeV2(formRow.idx, e)
                                              //validatePdtChange("pdtitem-"+formRow.idx, e.productid)
                                            }}
                                            components={{
                                              DropdownIndicator: () => null,
                                              IndicatorSeparator: () => null
                                            }}
                                            options={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].unitlist)}
                                            classNamePrefix="select2-selection"
                                            className="text-center"
                                            isLoading={false}
                                            id={"unitlist-"+key}
                                            menuPortalTarget= {document.body}
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].selectedunitoption)}
                                          />
                                          {(validation["unitlist-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Please select the Unit
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Rate
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleRateChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productrate-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].productrate)}
                                          />
                                          {(validation["productrate-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Rate
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Gross
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].productgross)}
                                          />
                                        </Col>
                                        
                                        
                                      </Row>
                                    </Col>
                                    <Col lg="4" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            type="text" // Gross without tax
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].productgrosswithouttax)}
                                          />
                                        </Col>
                                        <Col xs="2">
                                          <Input
                                            type="text" // Disc
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleDiscountChangeV2(formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].productdisc)}
                                          />
                                        </Col>

                                        <Col xs="2">
                                          <Input
                                            type="text" //GST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].productgst)}
                                          />
                                        </Col>
                                        
                                        <Col xs="5">
                                          <Input
                                            type="text" //Total
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesReturnRows.filter(x => x["idx"]==formRow.idx)[0].producttotal)}
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    
                                  </Row>
                                  
                                </td>
                              </tr>
                            ))}

                            <tr className="custom-table-footer">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="5" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="1"></Col>
                                      <Col className="pt-2 fw-medium display-10" xs="11">Total</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="3" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3">
                                        <Input
                                            type="text" // total qty
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={salesReturnEntry.totalqty || ''}
                                          />
                                      </Col>
                                      <Col className="" xs="3"></Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" //Gross
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesReturnEntry.totalgross || ''}
                                        />
                                      </Col>

                                      
                                      
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" // net - totalgrosswithouttax
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesReturnEntry.totalgrosswithouttax || ''}
                                        />
                                      </Col>
                                    {/*
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // CGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalcgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                      <Input
                                          type="text" // SGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalsgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="1">
                                        <Input
                                          type="text" // IGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totaligst || ''}
                                        />
                                      </Col>*/}
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // Disc
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesReturnEntry.totaldisc || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // GST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesReturnEntry.totalgst || ''}
                                        />
                                      </Col>
                                      
                                      <Col className="" xs="5">
                                        <InputGroup>
                                          <Input
                                              type="text" // Grand Total
                                              disabled
                                              className="nopadd text-center form-control"
                                              value={salesReturnEntry.totaltotal.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                          />
                                        </InputGroup>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    </>
                    }

                    {(validation["invalidsum"] === false) &&
                      <div className="text-center clearfix custom-error mb-3">
                        Grand Total & Invoice Total doesnt match. Please check.
                      </div>
                    }
                    
                    {isEdit &&<div className="text-center clearfix mt-3">
                      
                      <Button
                        color="success"
                        className="btn w-lg btn-success me-2"
                        onClick={() => {
                          addSalesReturnEntry()
                        }}
                        >
                          ADD SALES RETURN
                      </Button>
                    </div>}

                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>


      {showWarningPopUp ? (
        <SweetAlert
          warning
          title="Warning"
          onConfirm={() => {
            setShowWarningPopUp(false)
          }}
        >
          {warningMessage}
        </SweetAlert>
      ) : null}

      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
      {showSuccessPopUp ? (
        <SweetAlert
          title="Success!"
          success
          customButtons={
            <>
            <Button
              color="primary"
              className="btn btn-primary me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                onCreateNewSales()
              }}
              >
                <i className="bx bx-plus me-1"></i>Add New Sales
            </Button>
            <Button
              color="info"
              className="btn btn-info me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                handlePrint()
              }}
              >
                <i className="bx bx-printer me-1"></i>Print
            </Button>
            <Button
              color="warning"
              className="btn btn-warning me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
              }}
              >
                <i className="bx bx-window-close me-1"></i>Close
            </Button>
            </>
          }
          onConfirm={() => {
            setShowSuccessPopUp(false)
          }}
        >
          {successMessage}
        </SweetAlert>
      ) : null}

    </React.Fragment>
  )
}

export default SalesReturnEntry
